export const Links = {
	global: 'https://drive.google.com/drive/folders/1YRJf9NSjHVTiBCIyuHn7PMMNCayoc0Ia?usp=sharing',
};
